module.exports = __webpack_public_path__ + "img/feature-illustration-1.1eb6d52.svg";